import { createAction } from "redux-actions";
import { GET_OTHER_SERVICES } from "../constants";
import { feathersCreateData } from "../services";

export const getCollectionsOtherServices = createAction(GET_OTHER_SERVICES, () => feathersCreateData('core-server',{
    func : "RETURNS_OTHER_SERVICES", 
    service : "COLLECTIONS"
})())